import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import queryString from 'query-string'
import { sortBy } from '../../utils/helpers'
import BenchmarkingModalShell from '../Modals/BenchmarkingModalShell'

@observer
class BenchmarkingModal extends Component {
    changeYears = ({ value }) => {
        const { dashStore } = this.props
        // years Map keys are numbers but CheckboxGroup returns strings via returnValueUnchanged
        dashStore.changeYears({ value: value.map((v) => ({ value: Number(v) })) })
    }

    changePeriods = ({ value }) => {
        const { dashStore } = this.props
        dashStore.changeBenchmarkPeriod({ value: value[0] })
    }

    changeBenchmarks = ({ value }) => {
        const { dashStore } = this.props
        dashStore.changeBenchmarks({ value: value.map((v) => ({ value: v })) })
    }

    getIndustryName = (dashStore) => {
        const { appStore, oId, widgets, products, portfolios, scopeInfo } = dashStore
        const industries = R.pathOr(undefined, ['client', 'industries'], appStore)
        let industryCode
        if (oId <= 4) {
            // if company or division, only show industry if one unique industry is picked across widgets
            const industryCodes = new Set()
            widgets.forEach((w) => { industryCodes.add(w.industry) })
            industryCode = industryCodes.size === 1
                ? [...industryCodes][0]
                : undefined
        } else if (oId === 5) {
            const portfolio = portfolios.find((p) => p.portfolioId === scopeInfo?.value)
            industryCode = portfolio?.industry
        } else if (oId === 6) {
            // use queryString if ScopeSelector was not used (coming from surveyBuilder)
            const productId = scopeInfo?.value ?? Number(queryString.parse(window.location.search).productId)
            const product = products.find((p) => p.productId === productId)
            const portfolio = portfolios.find((p) => p.portfolioId === product?.portfolioId)
            industryCode = portfolio?.industry
        }
        const industry = industries?.find((i) => i.code === industryCode)
        return industry?.name
    }

    render() {
        const { dashStore, showBenchmarkingModal, toggleBenchmarkingModal } = this.props
        const {
            years,
            benchmarks,
            benchmarkLabels,
            benchmarkPeriods,
            benchmarkPeriod,
            possibleBenchmarks,
            oId,
            appStore,
        } = dashStore

        const standardKeys = possibleBenchmarks[oId] ?? []
        const benchmarkOptions = standardKeys.map((key) => ({
            label: benchmarkLabels[key],
            value: key,
        }))

        const selectedBenchmarks = Array.from(benchmarks)
            .filter(([, v]) => !!v)
            .map(([key]) => key)

        const yearOptions = sortBy(
            Array.from(years)
                .filter(([y]) => y >= 1900)
                .map(([y]) => ({ label: String(y), value: String(y) })),
            'value', -1,
        )

        const selectedYears = Array.from(years)
            .filter(([y, v]) => y >= 1900 && !!v)
            .map(([y]) => String(y))

        const industry = this.getIndustryName(dashStore)

        return (
            <BenchmarkingModalShell
                storeType="dashboard"
                show={showBenchmarkingModal}
                industry={industry}
                onClose={toggleBenchmarkingModal}
                langcode={appStore.langcode}
                benchmarkOptions={benchmarkOptions}
                selectedBenchmarks={selectedBenchmarks}
                customBenchmarkTags={dashStore.benchmarkTags}
                changeBenchmarks={this.changeBenchmarks}
                periodOptions={benchmarkPeriods}
                selectedPeriods={[benchmarkPeriod]}
                changePeriods={this.changePeriods}
                yearOptions={yearOptions}
                selectedYears={selectedYears}
                changeYears={this.changeYears}
            />
        )
    }
}

export default BenchmarkingModal
